import { render, staticRenderFns } from "./team_review.vue?vue&type=template&id=d3a5777e&scoped=true&"
import script from "./team_review.vue?vue&type=script&lang=js&"
export * from "./team_review.vue?vue&type=script&lang=js&"
import style0 from "./team_review.vue?vue&type=style&index=0&id=d3a5777e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a5777e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a5777e')) {
      api.createRecord('d3a5777e', component.options)
    } else {
      api.reload('d3a5777e', component.options)
    }
    module.hot.accept("./team_review.vue?vue&type=template&id=d3a5777e&scoped=true&", function () {
      api.rerender('d3a5777e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/view-team/team_review.vue"
export default component.exports